<template>
  <div>
    <v-container class="px-8 py-6">
      <PageHeader class="mb-6" :backButton="false">
        <template v-slot:title>Users</template>
        <template v-slot:actions>
          <v-btn color="secondary" @click="onNewUserClicked">
            <v-icon left>mdi-plus</v-icon>
            New User
          </v-btn>
        </template>
      </PageHeader>

      <RequestTable
        ref="requestTable"
        :actions="actions"
        :pagination="true"
        :request="getUsersAsync"
        :showColumns="[
          'email',
          'supplier.internalId',
          'supplier.supplierName',
          'role.roleName',
          'createdDate',
        ]"
      />
    </v-container>
  </div>
</template>

<script>
import api from "../../../api";
import { TableAction } from "../../../components/tables/Table/TableAction";
import { navigation } from "../../../router";
import dates from "../../../utils/dates";
export default {
  data() {
    return {
      actions: [
        new TableAction("Overview", {
          icon: "information-outline",
          click: (user) => {
            const route = navigation.main.users.details(user.userId);
            this.$router.push(route);
          },
        }),
      ],
    };
  }, // data

  mounted() {}, // mounted

  methods: {
    onNewUserClicked() {
      this.$router.push(navigation.main.users.new);
    },
    async getUsersAsync({ pageIndex, pageSize }) {
      const tableResponse = await api.users.getPagedAsync({
        pageIndex,
        pageSize,
      });
      tableResponse.data.forEach((user) => {
        user.createdDate = dates.MMDDYYYYHHmmss(user.createdDate);
      });
      return tableResponse;
    },
  }, // methods
};
</script>
